export const SOFTLINE_API_SCAN_QUELLLAGERPLATZ = "/v1/lagerplatzinhalt/scan-lagerplatz/{{code}}";
export const SOFTLINE_API_SCAN_PALETTE = "/v1/lagerplatzinhalt/scan-palette/{{code}}";
export const SOFTLINE_API_SCAN_ZIELLAGERPLATZ = "/v1/lagerplatz/scan/{{code}}";
export const SOFTLINE_API_UMLAGERUNG = '/v1/umlagerung';
